import React, { useCallback, useEffect, useState } from "react";
import Modal from "../../../elements/Modal";
import Image from "../../../elements/Image";
import AuthImage from "../../../../assets/images/auth-image.svg";
import Input from "../../../form/Input";
import TitleDecoration from "../../../elements/TitleDecoration";
import Button from "../../../forms/Button";
import GoogleLogo from "../../../../assets/image/google.svg";
import FacebookLogo from "../../../../assets/image/facebook.svg";
import { classNames } from "../../../../helpers/classNames";
import { AnimatePresence, motion } from "framer-motion";
import { useBanner } from "../../../../providers/BannerProviders";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useForm from "../../../../hooks/useForm";
import useMutation from "../../../../hooks/useMutation";
import { authSignup } from "../../../../services/authService";
import { login } from "../../../../redux/slice/authSlice";
import { toast } from "react-toastify";

const transitionVariants = {
  initial: { opacity: 0, x: 50 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 },
};
const signUpValidation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
  confirmPassword: { required: true, message: "Confirm Password is Required" },
  firstName: { required: true, message: "Please Enter the First Name" },
  lastName: { required: true, message: "Please Enter the Last Name" },
};

const signInValidation = {
  loginEmail: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  loginPassword: { required: true, message: "Password is Required" },
};
// const Signin = ({
//   socialData,
//   switchToSignup,
//   switchToForgot,
//   currentView,
// }) => {
//   const { data } = useBanner();
//   const signInText = data?.data?.find(
//     (item) => item?.slug === "signin-1748585734840"
//   );
//   const { session, loginPending } = useSelector((state) => state?.authProvider);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const {
//     values,
//     handleChange,
//     handleSubmit,
//     errors,
//     setFieldsValue,
//     resetField,
//     formValidate,
//   } = useForm({
//     validationRules:
//       currentView === "signup" ? signUpValidation : signInValidation,
//   });
//   const {
//     mutate: signup,
//     error: signUpError,
//     isPending: signUpPending,
//     data: signUpData,
//   } = useMutation({
//     mutationFn: async (val) => {
//       return await authSignup({
//         ...val,
//         requestType: "SIGNUP",
//       });
//     },
//     onSuccess: async (res) => {
//       if (res?.status === 200) {
//         navigate("/otp-verification");
//       } else {
//         toast.warning(res?.message);
//       }
//     },
//   });

//   const handleFormSubmit = useCallback(
//     (event) => {
//       handleSubmit(
//         event,
//         currentView === "signin"
//           ? (val) => {
//               dispatch(
//                 login({
//                   email: val?.loginEmail,
//                   password: val?.loginPassword,
//                   redirect: "/dashboard",
//                   navigate,
//                   location,
//                 })
//               );
//             }
//           : signup
//       );
//     },
//     [handleSubmit]
//   );
//   const handleClick = () => {
//     navigate("/forgot-password", {
//       state: "user",
//     });
//   };

//   return (
//     <motion.div
//       key="signin"
//       initial="initial"
//       animate="animate"
//       exit="exit"
//       variants={transitionVariants}
//       transition={{ duration: 0.3 }}
//     >
//       <div className="relative bg-white rounded-xl py-8 px-8 shadow-lg">
//         <div className="space-y-4">
//           <div className="relative space-y-2 mb-6">
//             <h2 className="font-BubblegumSans text-3xl text-black">
//               {signInText?.title || "Signin"}
//             </h2>
//             <TitleDecoration classes={"!justify-start"} />
//             <div className="text-base !mt-4">
//               {signInText?.description ||
//                 " Welcome back! Please enter your credentials to access your account."}
//             </div>
//           </div>
//           <div className="space-y-4">
//             <div className="relative">
//               <Input
//                 inputPlaceholder={"Enter email address"}
//                 inputClasses={
//                   "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
//                 }
//                 label={"Username / Email"}
//                 labelClasses={"font-Fredoka !text-black !text-sm"}
//                 inputType={"email"}
//                 inputName="loginEmail"
//                 value={values?.loginEmail}
//                 onChange={handleChange}
//                 {...formValidate(errors, "loginEmail")}
//               />
//             </div>
//             <div className="relative">
//               <Input
//                 inputPlaceholder={"Enter password"}
//                 inputClasses={
//                   "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
//                 }
//                 label={"Password"}
//                 labelClasses={"font-Fredoka !text-black !text-sm"}
//                 inputType={"password"}
//                 inputName="loginPassword"
//                 value={values?.loginPassword}
//                 onChange={handleChange}
//                 {...formValidate(errors, "loginPassword")}
//               />
//             </div>
//             <div className="relative !mt-8">
//               <Button
//                 buttonHasLink={false}
//                 buttonLabel={"Sign in"}
//                 buttonLabelClasses={"text-xl uppercase"}
//                 buttonClasses={
//                   "bg-gradient-to-tr from-md-red to-md-yellow h-14 !px-12 w-full"
//                 }
//                 // buttonFunction={() => {}}
//                 // buttonFunction={handleFormSubmit}
//               />
//             </div>
//             <div className="relative flex justify-center !mt-2">
//               <Button
//                 buttonHasLink={false}
//                 buttonIcon={"fa-regular fa-circle-question text-sm"}
//                 buttonIconPosition={"left"}
//                 buttonLabel={"Forgot Password"}
//                 buttonLabelClasses={"!text-sm"}
//                 buttonClasses={
//                   "!h-auto !px-0 !rounded-none !bg-transparent !text-md-indigo"
//                 }
//                 buttonFunction={switchToForgot}
//               />
//             </div>
//           </div>
//           <div className="overflow-hidden flex items-center justify-center relative">
//             <span
//               className={classNames(
//                 "relative inline-flex items-center justify-center bg-transparent text-slate-400 capitalize",
//                 "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-slate-200 before:mt-px",
//                 "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-slate-200 after:mt-px"
//               )}
//             >
//               or
//             </span>
//           </div>
//           {socialData?.length > 0 && (
//             <div className="flex items-center justify-center gap-2">
//               {socialData.map((item, index) => (
//                 <Button
//                   key={item._id}
//                   buttonClasses="!bg-transparent !rounded-xl !p-2 !h-auto border border-slate-200 w-full hover:bg-md-light-blue"
//                   buttonLabel={
//                     <div className="flex items-center gap-1 md:gap-2">
//                       <div className="w-8 aspect-square overflow-hidden">
//                         <Image
//                           src={item.logo}
//                           alt={item.name}
//                           effect={"blur"}
//                           classes={"object-contain"}
//                         />
//                       </div>
//                       <div className="text-black text-base">{item.name}</div>
//                     </div>
//                   }
//                 />
//               ))}
//             </div>
//           )}
//           <div className="text-center flex items-center justify-center text-sm text-slate-400">
//             <span>Don’t have an account?</span>
//             <Button
//               buttonLabel={"Signup"}
//               buttonLabelClasses={"!text-sm !font-medium"}
//               buttonClasses={
//                 "!h-auto !py-1 !px-1 !bg-white !text-md-indigo !rounded-none underline"
//               }
//               buttonFunction={switchToSignup}
//             />
//             <span>here</span>
//           </div>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

const Signup = ({
  socialData,
  switchToSignin,
  switchToForgot,
  switchToSuccess,
  currentView,
  loginWithRedirect,
}) => {
  const { data } = useBanner();
  const signUpText = data?.data?.find(
    (item) => item?.slug === "signup-1748585652606"
  );

  const navigate = useNavigate();
  const { values, handleChange, handleSubmit, errors, formValidate } = useForm({
    validationRules: signUpValidation,
  });

  const {
    mutate: signup,
    error: signUpError,
    isPending: signUpPending,
    data: signUpData,
  } = useMutation({
    mutationFn: async (val) => {
      return await authSignup({ ...val, requestType: "SIGNUP" });
    },
    onSuccess: async (res) => {
      console.log(res, "res");
      if (res?.status === 201) {
        switchToSuccess();
      } else {
        toast.warning(res?.message);
      }
    },
  });

  const handleFormSubmit = useCallback(
    (event) => {
      handleSubmit(event, signup);
    },
    [handleSubmit]
  );
  return (
    <motion.div
      key="signup"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={transitionVariants}
      transition={{ duration: 0.3 }}
    >
      <div className="relative bg-white rounded-xl py-8 px-8 shadow-lg">
        <div className="space-y-4">
          <div className="relative space-y-2 mb-6">
            <h2 className="font-BubblegumSans text-3xl text-black">
              {signUpText?.title || "Signup"}
            </h2>
            <TitleDecoration classes={"!justify-start"} />
            <div className="text-base !mt-4">
              {signUpText?.description ||
                "Create a new account to start turning your memories into art!"}
            </div>
          </div>
          <div className="space-y-4">
            <div className="relative">
              <Input
                inputPlaceholder={"Enter firstname name"}
                inputClasses={
                  "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
                }
                label={"First Name"}
                labelClasses={"font-Fredoka !text-black !text-sm"}
                inputName="firstName"
                value={values?.firstName}
                onChange={handleChange}
                {...formValidate(errors, "firstName")}
              />
            </div>
            <div className="relative">
              <Input
                inputPlaceholder={"Enter last name"}
                inputClasses={
                  "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
                }
                label={"Last Name"}
                labelClasses={"font-Fredoka !text-black !text-sm"}
                inputName="lastName"
                value={values?.lastName}
                onChange={handleChange}
                {...formValidate(errors, "lastName")}
              />
            </div>
            <div className="relative">
              <Input
                inputPlaceholder={"Enter email address"}
                inputClasses={
                  "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
                }
                label={"Email"}
                labelClasses={"font-Fredoka !text-black !text-sm"}
                inputName="email"
                value={values?.email}
                onChange={handleChange}
                {...formValidate(errors, "email")}
              />
            </div>
            <div className="relative">
              <Input
                inputPlaceholder={"Enter password"}
                inputClasses={
                  "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
                }
                label={"Password"}
                labelClasses={"font-Fredoka !text-black !text-sm"}
                inputType={"password"}
                inputName="password"
                value={values?.password}
                onChange={handleChange}
                {...formValidate(errors, "password")}
              />
            </div>
            <div className="relative">
              <Input
                inputPlaceholder={"Re-enter password"}
                inputClasses={
                  "font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
                }
                label={"Confirm Password"}
                labelClasses={"font-Fredoka !text-black !text-sm"}
                inputType={"password"}
                inputName="confirmPassword"
                value={values?.confirmPassword}
                onChange={handleChange}
                {...formValidate(errors, "confirmPassword")}
              />
            </div>
            <div className="relative !mt-8">
              <Button
                buttonHasLink={false}
                buttonLabel={"Sign up"}
                buttonLabelClasses={"text-xl uppercase"}
                buttonClasses={
                  "bg-gradient-to-tr from-md-red to-md-yellow h-14 !px-12 w-full"
                }
                buttonFunction={handleFormSubmit}
              />
            </div>
            <div className="relative flex justify-center !mt-2">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-circle-question text-sm"}
                buttonIconPosition={"left"}
                buttonLabel={"Forgot Password"}
                buttonLabelClasses={"!text-sm"}
                buttonClasses={
                  "!h-auto !px-0 !rounded-none !bg-transparent !text-md-indigo"
                }
                buttonFunction={switchToForgot}
              />
            </div>
          </div>
          <div className="overflow-hidden flex items-center justify-center relative">
            <span
              className={classNames(
                "relative inline-flex items-center justify-center bg-transparent text-slate-400 capitalize",
                "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-slate-200 before:mt-px",
                "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-slate-200 after:mt-px"
              )}
            >
              or
            </span>
          </div>
          {socialData?.length > 0 && (
            <div className="flex items-center justify-center gap-2">
              {socialData.map((item, index) => (
                <Button
                  key={item._id}
                  buttonClasses="!bg-transparent !rounded-xl !p-2 !h-auto border border-slate-200 w-full hover:bg-md-light-blue"
                  buttonLabel={
                    <div className="flex items-center gap-1 md:gap-2">
                      <div className="w-8 aspect-square overflow-hidden">
                        <Image
                          src={item.logo}
                          alt={item.name}
                          effect={"blur"}
                          classes={"object-contain"}
                        />
                      </div>
                      <div className="text-black text-base">{item.name}</div>
                    </div>
                  }
                />
              ))}
            </div>
          )}
          <div className="text-center flex items-center justify-center text-sm text-slate-400">
            <span>Already have an account?</span>
            <Button
              buttonLabel={"Login"}
              buttonLabelClasses={"!text-sm !font-medium"}
              buttonClasses={
                "!h-auto !py-1 !px-1 !bg-white !text-md-indigo !rounded-none underline"
              }
              buttonFunction={() => loginWithRedirect()}
            />
            <span>here</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const ForgotPassword = ({ switchToSignup, currentView }) => {
  return (
    <motion.div
      key="forgot"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={transitionVariants}
      transition={{ duration: 0.3 }}
    >
      <div className="relative bg-white rounded-xl py-8 px-8 shadow-lg">
        <div className="space-y-4">
          <div className="relative space-y-2 mb-6">
            <h2 className="font-BubblegumSans text-3xl text-black">
              Forgot Password
            </h2>
            <TitleDecoration classes={"!justify-start"} />
            <div className="text-base !mt-4">
              Enter your email and we'll send you instructions to reset your
              password.
            </div>
          </div>
          <div className="space-y-4">
            <div className="relative">
              <Input
                inputPlaceholder="Enter your email"
                inputClasses="font-Fredoka !text-black !text-base !h-12 !rounded-full !px-6"
                label="Email"
                labelClasses="font-Fredoka !text-black !text-sm"
              />
            </div>
            <div className="relative !mt-8">
              <Button
                buttonHasLink={false}
                buttonLabel="Send Reset Link"
                buttonLabelClasses="text-xl uppercase"
                buttonClasses="bg-gradient-to-tr from-md-red to-md-yellow h-14 !px-12 w-full"
                buttonFunction={() => {}}
              />
            </div>
            <div className="flex justify-center !mt-2">
              <Button
                buttonLabel="Back to Signup"
                buttonLabelClasses="!text-sm !font-medium"
                buttonClasses="!h-auto !bg-transparent !text-md-indigo underline"
                buttonFunction={switchToSignup}
              />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
const SuccessPage = ({ loginWithRedirect }) => {
  return (
    <motion.div
      key="success"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={transitionVariants}
      transition={{ duration: 0.3 }}
    >
      <div className="relative bg-white rounded-xl py-8 px-8 shadow-lg">
        <div className="space-y-4">
          <div className="relative space-y-2 mb-6">
            <h2 className="font-BubblegumSans text-3xl text-black">
              User Created Successfully
            </h2>
            <TitleDecoration classes={"!justify-start"} />
            <div className="text-base !mt-4">
              Welcome Back! Please login to access you account.
            </div>
          </div>
          <div className="space-y-4">
            <div className="relative !mt-8">
              <Button
                buttonHasLink={false}
                buttonLabel={"Login Now"}
                buttonLabelClasses={"text-xl uppercase"}
                buttonClasses={
                  "hover:scale-105 bg-gradient-to-tr from-md-red to-md-yellow 3xl:h-14 !px-8 3xl:!px-12"
                }
                buttonFunction={() => loginWithRedirect()}
              />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
const Authentications = ({
  authenticationModal,
  loginWithRedirect,
  setAuthenticationModal,
}) => {
  const [view, setView] = useState("signup");

  const socialData = [
    { _id: 1, name: "Facebook", logo: FacebookLogo },
    { _id: 2, name: "Google", logo: GoogleLogo },
  ];
  const { data } = useBanner();
  const authenticationLeft = data?.data?.find(
    (item) => item?.slug === "ready-to-create-magical-memories-1748585224015"
  );

  return (
    <>
      <Modal
        isOpen={authenticationModal}
        setIsOpen={setAuthenticationModal}
        size="xl5"
        header={false}
        isClose={false}
        bodyClasses={"!p-0"}
      >
        <div className="w-full rounded-2xl bg-gradient-to-tl from-md-dark-indigo to-indigo-950 py-10 px-10">
          <div className="grid grid-cols-2 gap-5 items-center">
            <div className="relative px-6">
              <div className="space-y-10">
                <div className="space-y-4">
                  <h2 className="font-BubblegumSans text-5xl text-transparent bg-gradient-to-br from-md-yellow via-md-orange to-md-red bg-clip-text inline-block">
                    {authenticationLeft?.title ||
                      "Ready to Create Magical Memories?"}
                  </h2>
                  <div className="text-white/80 text-xl font-ShantellSans font-light">
                    {authenticationLeft?.description ||
                      "Bring your memories to life with a creative twist—turn your favorite family moments into personalized coloring pages!"}
                  </div>
                </div>
                <div className="flex">
                  <Image
                    src={authenticationLeft?.image?.[0]?.url || AuthImage}
                    alt={authenticationLeft?.image?.[0]?.filename || ""}
                    width={"100%"}
                    height={"100%"}
                    effect={"blur"}
                    classes={"object-contain"}
                  />
                </div>
              </div>
            </div>
            <motion.div
              layout
              transition={{ duration: 0.4 }}
              className="relative w-full"
            >
              <AnimatePresence mode="wait">
                {/* {view === "signin" && (
                  <Signin
                    key="signin"
                    socialData={socialData}
                    switchToSignup={() => setView("signup")}
                    switchToForgot={() => setView("forgot")}
                    currentView="signin"
                  />
                )} */}
                {view === "signup" && (
                  <Signup
                    key="signup"
                    socialData={socialData}
                    switchToSignin={() => setView("signin")}
                    switchToForgot={() => setView("forgot")}
                    switchToSuccess={() => setView("success")}
                    loginWithRedirect={loginWithRedirect}
                    currentView="signup"
                  />
                )}
                {view === "forgot" && (
                  <ForgotPassword
                    key="forgot"
                    switchToSignup={() => setView("signup")}
                    currentView="forgot"
                  />
                )}
                {view === "success" && (
                  <SuccessPage
                    key="success"
                    loginWithRedirect={loginWithRedirect}
                  />
                )}
              </AnimatePresence>
            </motion.div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Authentications;
